// THE 定数
module.exports = {
  settings: {
    lineColor:    '#aaa',
    lineSize:     5,
    boardColor:   'transparent',
    historyDepth: 10
  }
};
